<div class="dashboard h-100">
    <div class="dashboard-card no-padding d-flex flex-column justify-content-between"
        style="max-width: 800px">
        <div class="row">
            <div class="col-12">
                <div class="padding-container d-flex flex-column">
                    <h2 class="card-dash-title">Agentes para prestador de
                        serviços</h2>
                </div>
            </div>

            <div class="col-12 dashboard-card-body">
                <ng-container *ngIf="loading">
                    <table #table class="bordered">
                        <tbody>
                            <tr *ngFor="let number of [0,1,2,3,4,5,6]">
                                <td>
                                    <ngx-skeleton-loader [theme]="{
                                        height: '16px',
                                        width: '200px',
                                        marginBottom:'0'
                                      }">
                                    </ngx-skeleton-loader>
                                </td>
                                <td class="item-number">
                                    <ngx-skeleton-loader [theme]="{
                                        height: '16px',
                                        width: '40px',
                                        marginBottom:'0',
                                        marginLeft: 'auto'
                                      }">
                                    </ngx-skeleton-loader>
                                </td>
                                <td>
                                    <div
                                        style="display: flex; gap: 8px; justify-content: flex-end;">
                                        <ngx-skeleton-loader [theme]="{
                                            height: '16px',
                                            width: '16px',
                                            marginBottom:'0',
                                            borderRadius: '0'
                                          }">
                                        </ngx-skeleton-loader>
                                        <ngx-skeleton-loader [theme]="{
                                            height: '16px',
                                            width: '16px',
                                            marginBottom:'0',
                                            borderRadius: '0'
                                          }">
                                        </ngx-skeleton-loader>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </ng-container>

                <table #table class="bordered"
                    *ngIf="!loading && agents.length > 0">
                    <thead>
                        <tr>
                            <th>Agente</th>
                            <th style="text-align:right;">Qtde. de Vínculos</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let agent of visible_agents">
                            <td>{{agent.name}}</td>
                            <td style="text-align:right;">
                                <ng-container *ngIf="agent.users">
                                    {{agent.users.length}}
                                </ng-container>
                            </td>
                            <td class="pl-0">
                                <div class="table-options">
                                    <app-tooltip text="Editar"
                                        *ngIf="permissionObj.canChange">
                                        <button (click)="setAgent(agent)">
                                            <svg-icon
                                                src="assets/images/icon-edit.svg"></svg-icon>
                                        </button>
                                    </app-tooltip>
                                    <app-spacer [right]="8"></app-spacer>
                                    <app-tooltip
                                        [text]="(agent.users && agent.users.length > 0) ? 'Não é possível excluir agente com vínculos' : 'Excluir'"
                                        *ngIf="permissionObj.canChange">
                                        <button (click)="openDeleteModal(agent)"
                                            [disabled]="agent.users && agent.users.length > 0">
                                            <svg-icon
                                                src="assets/images/icon-trash.svg"></svg-icon>
                                        </button>
                                    </app-tooltip>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="col-12">
                <div class="padding-container d-flex flex-row justify-content-between"
                    *ngIf="loading || agents.length > 0">
                    <app-button [inverted]="true"
                        (onClick)="redirect('/app/settings/agents')">
                        Ver todos
                    </app-button>

                    <app-button (click)="addAgentsToggle(true)"
                        class="add-button" [disabled]="loading"
                        *ngIf="permissionObj.canAdd">
                        <svg-icon src="assets/images/icon-add.svg"
                            class="mr-2 mt-1 mb-1"></svg-icon>Adicionar
                        agente</app-button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 " *ngIf="agents.length === 0 && !loading">
                <div class="empty-card">
                    <div class="img-container">
                        <img src="/assets/images/collaborator-icon.png"
                            alt="icone">
                    </div>

                    <ng-container *ngIf="!permissionObj.canAdd">
                        <h3>
                            Ainda não existem agentes cadastrados
                        </h3>
                    </ng-container>

                    <ng-container *ngIf="permissionObj.canAdd">
                        <h3>Adicione o primeiro agente</h3>
                        <p>
                            Curabitur maximus ipsum non quam bibendum facilisis.
                            Ut
                            sollicitudin id erat vel
                        </p>

                        <app-button (click)="addAgentsToggle(true)"
                            class="add-button">
                            <svg-icon src="assets/images/icon-add.svg"
                                class="mr-2"></svg-icon>Adicionar
                            agente
                        </app-button>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<app-side-modal [active]="addAgents" (onClose)="closeModal()">
    <ng-container *ngIf="addAgents">
        <form class="row" [formGroup]="agentsForm">
            <div class="col-12">
                <span class="card-info-form-title">
                    {{agent ? 'Editar agente' : 'Novo agente'}}
                </span>
                <app-spacer [bottom]="8"></app-spacer>
            </div>

            <div class="col-12">
                <span class="card-info-form-description">
                    {{agent ? 'Editar agente' : 'Adicione um novo agente ao seu
                    sistema.'}}
                    {{agent ? agent.name : ''}}
                </span>
                <app-spacer [bottom]="48"></app-spacer>
            </div>

            <div class="col-12">
                <app-input label="Nome" [group]="agentsForm" controlName="name">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12 col-lg-6">
                <app-button [disabled]="agentsForm.invalid"
                    (click)="addAgent()">
                    {{agent ? 'Atualizar agente' : 'Salvar novo agente'}}
                </app-button>
            </div>
        </form>
    </ng-container>
</app-side-modal>

<!-- Carbon Warning Modals -->
<app-carbon-warning-modal [active]="showDeleteModal"
    [title]="getDeleteModalTitle()" [message]="getDeleteModalMessage()"
    [confirmText]="getDeleteConfirmText()" [cancelText]="getDeleteCancelText()"
    [confirmAction]="confirmDeleteAgent.bind(this)"
    [cancelAction]="closeDeleteModal.bind(this)" (onClose)="closeDeleteModal()">
</app-carbon-warning-modal>

<!-- Modal de migração com select -->
<div class="modal" [class.active]="showMigrationModal"
    *ngIf="showMigrationModal">
    <div class="modal-content">
        <div class="modal-header">
            <h3>{{getMigrationModalTitle()}}</h3>
            <button class="close-button" (click)="closeMigrationModal()">
                <svg-icon src="assets/images/icon-times.svg"></svg-icon>
            </button>
        </div>
        <div class="modal-body">
            <p>{{getMigrationModalMessage()}}</p>
            <app-select [items]="getMigrationOptionsArray()"
                [(ngModel)]="selectedMigrationRole"
                label="Selecione o papel para migração">
            </app-select>
        </div>
        <div class="modal-footer">
            <button class="btn btn-secondary" (click)="closeMigrationModal()">
                {{getMigrationCancelText()}}
            </button>
            <button class="btn btn-primary" [disabled]="!selectedMigrationRole"
                (click)="confirmMigration(selectedMigrationRole)">
                {{getMigrationConfirmText()}}
            </button>
        </div>
    </div>
</div>

<app-carbon-warning-modal [active]="showSuccessModal"
    [title]="getSuccessModalTitle()" [message]="getSuccessModalMessage()"
    [confirmText]="getSuccessConfirmText()" [cancelText]="''"
    [confirmAction]="closeSuccessModal.bind(this)"
    [cancelAction]="closeSuccessModal.bind(this)"
    (onClose)="closeSuccessModal()">
</app-carbon-warning-modal>

<app-carbon-warning-modal [active]="showErrorModal"
    [title]="getErrorModalTitle()" [message]="getErrorModalMessage()"
    [confirmText]="getErrorConfirmText()" [cancelText]="''"
    [confirmAction]="closeErrorModal.bind(this)"
    [cancelAction]="closeErrorModal.bind(this)" (onClose)="closeErrorModal()">
</app-carbon-warning-modal>